export interface StepperModel {
    isHide: boolean;
    firstPartnerStep: StepData;
    contractDurationStep: StepData;
    contractDataStep: StepData;
    reviewStep: StepData;
}
export interface StepData {
    order: number;
    title: string;
    stepClass: string;
    status: StepStatus;

}
export enum StepStatus {
    active = 1,
    done = 2,
    next = 3

}